// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"3e82142a","347":"4c949e59","494":"58c3cd59","523":"c846ec3c","570":"56824f9f","714":"a9bf3547","946":"a7b8e732"}[chunkId] + ".chunk.js";
};